// extracted by mini-css-extract-plugin
export default {"content":"Rpa-z","title":"Spa-z","subTitle":"Tpa-z","banner":"Upa-z","productCardOverride":"Vpa-z"};